import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { GETWORKSPACEDATA_URL, SAVEWORKSPACEDATA_URL } from "../service/data";
const initialState = {
  workspaceData: [],
  savedWorkspaceData: [],
  netZeroPathwayData: [],
  finalWorkspaceData: [],
  materials: [],
  scenario: "",
  changedMaterial: "",
  region: [],
  workspaceDataSaveLoading: false,
  workspaceDataSaveError: null,
  workspaceDataSaveSuccess: false,
  workspaceDataSaveStatus: null,
  getWorkspaceDataLoading: false,
  getWorkspaceDataError: null,
  getWorkspaceDataSuccess: false,
  getWorkspaceDataStatus: null,
  popupWorkspaceDataSuccess: false,
  assessmentId:null,
};

export const workspaceSaveDataCall = createAsyncThunk(
  "workspaceData/workspaceSaveDataCall",
  async ({ accessToken, savedItems }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          //Authorization: accessToken ? `Bearer ${accessToken}` : "",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Methods": "*",
        },
      };
      const assessment_id = savedItems.assessment_id;

      const { data } = await axios.post(
        `${SAVEWORKSPACEDATA_URL}/${assessment_id}/workspace`,
        savedItems,
        config
      );

      return data;
    } catch (error) {
      if (error.message && error.message === "Network Error") {
        return rejectWithValue(error.message);
      }
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getWorkSpaceData = createAsyncThunk(
  "workspaceData/getWorkSpaceData",
  async ({ id, accessToken }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          //Authorization: accessToken ? `Bearer ${accessToken}` : "",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Methods": "*",
        },
      };
      const { data } = await axios.get(`${GETWORKSPACEDATA_URL}/${id}`, config);
      sessionStorage.setItem("assessmentId", data.assessment_unique_id);
      return data;
    } catch (error) {
      if (error.message && error.message === "Network Error") {
        return rejectWithValue(error.message);
      }
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const workspaceDataSlice = createSlice({
  name: "workspaceData",
  initialState,
  reducers: {
    setWorkspaceInitialData: (state, { payload }) => {
      state.workspaceData = payload;
      state.getWorkspaceDataLoading = false;
      state.popupWorkspaceDataSuccess = true;
    },
    setAssessmentId: (state, {payload})=>
    {
      state.assessmentId = payload;
    },
    setMaterials: (state, { payload }) => {
      state.materials = payload;
    },
    setScenario: (state, { payload }) => {
      state.scenario = payload;
    },
    setRegion: (state, { payload }) => {
      state.region = payload;
    },
    setFinalWorkspaceData: (state, { payload }) => {
      state.finalWorkspaceData = payload;
    },
    setWorkspaceDataSaveSuccess: (state) => {
      state.workspaceDataSaveSuccess = false;
      state.getWorkspaceDataSuccess = false;
    },
    setChangedMaterial: (state, { payload }) => {
      state.changedMaterial = payload;
    },
    setWorkspaceData: (state, { payload }) => {
      return {
        ...state,
        savedWorkspaceData: payload,
      };
    },
    getWorkSpaceDataSuccessCall: (state) => {
      state.getWorkspaceDataSuccess = false;
    },
    saveWorkspaceData: (state, action) => {
      const { rowId, updatedData } = action.payload;

      let isIdMatched = false;
      const updatedWorkspaceData = state.finalWorkspaceData.map((obj) => {
        if (obj.id === rowId) {
          isIdMatched = true;
          return { ...obj, ...updatedData };
        }

        return obj;
      });

      if (!isIdMatched) {
        updatedWorkspaceData.push(updatedData);
      }

      state.finalWorkspaceData = updatedWorkspaceData;
    },
    clearWorkspaceData: (state, { payload: { material, scenario } }) => {
      const clearedRowData = state.savedWorkspaceData.map((row) => {
        if (row.material === material && row.scenario === scenario) {
          if (row.scenario == "Base") {
            return {
              ...row,
              quantity: 0,
            };
          } else {
            return {
              ...row,
              quantity: 0,
              emission_intensity: "",
              product: "",
              subproduct: "",
            };
          }
        }
        return row;
      });

      return {
        ...state,
        savedWorkspaceData: clearedRowData,
      };
    },

    updateWorkspaceData: (state, action) => {
      const { rowId, updatedData } = action.payload;

      let isIdMatched = false;
      const updatedWorkspaceData = state.savedWorkspaceData.map((obj) => {
        if (obj.id === rowId) {
          isIdMatched = true;
          return { ...obj, ...updatedData };
        }

        return obj;
      });

      if (!isIdMatched) {
        updatedWorkspaceData.push(updatedData);
      }

      state.savedWorkspaceData = updatedWorkspaceData;
    },
    saveNetZeroPathwayData: (state, { payload }) => {
      state.netZeroPathwayData = payload;
    },
  },
  extraReducers: {
    [workspaceSaveDataCall.pending]: (state) => {
      state.workspaceDataSaveLoading = true;
      state.workspaceDataSaveSuccess = false;
      state.workspaceDataSaveError = null;
    },
    [workspaceSaveDataCall.fulfilled]: (state, { payload }) => {
      state.workspaceDataSaveLoading = false;
      state.workspaceDataSaveSuccess = true;
      state.finalWorkspaceData = payload;
    },
    [workspaceSaveDataCall.rejected]: (state, { payload }) => {
      state.workspaceDataSaveLoading = false;
      state.workspaceDataSaveError = payload;
    },
    [getWorkSpaceData.pending]: (state) => {
      state.getWorkspaceDataLoading = true;
      state.getWorkspaceDataSuccess = false;
      state.getWorkspaceDataError = null;
    },
    [getWorkSpaceData.fulfilled]: (state, { payload }) => {
      state.getWorkspaceDataLoading = false;
      state.getWorkspaceDataSuccess = true;
      state.popupWorkspaceDataSuccess = false;
      state.workspaceData = payload;
    },
    [getWorkSpaceData.rejected]: (state, { payload }) => {
      state.getWorkspaceDataLoading = false;
      state.getWorkspaceDataError = payload;
    },
  },
});

export const {
  setWorkspaceDataSaveSuccess,
  getWorkSpaceDataSuccessCall,
  setWorkspaceInitialData,
  setWorkspaceData,
  setMaterials,
  setScenario,
  setRegion,
  setFinalWorkspaceData,
  setChangedMaterial,
  saveWorkspaceData,
  clearWorkspaceData,
  updateWorkspaceData,
  saveNetZeroPathwayData,
  setAssessmentId,
} = workspaceDataSlice.actions;

export default workspaceDataSlice.reducer;
